import * as RadixTabs from '@radix-ui/react-tabs';
import { motion } from 'motion/react';

import { easeOutExpo } from '@components/primitives/utilities';

import { useTabs } from './Context';

import css from './styles.module.css';

export interface TriggerProps {
  label: string;
  icon?: React.ReactNode;
}

export function Trigger({ label, icon }: TriggerProps) {
  const { value } = useTabs();

  return (
    <RadixTabs.Trigger className={css.tab} value={label}>
      {icon && (
        <span className={css.icon} aria-hidden>
          {icon}
        </span>
      )}
      {label}
      {label === value && (
        <motion.div
          layoutId="indicator"
          className={css.indicator}
          transition={{ duration: 0.3, ease: easeOutExpo }}
        />
      )}
    </RadixTabs.Trigger>
  );
}
